




































import { Component, Vue, Prop } from 'vue-property-decorator'
import shortid from 'shortid'

@Component({
  inheritAttrs: false,
})
export default class CheckboxesInput extends Vue {
  @Prop({ type: String, default: 'text' })
  type!: 'text' | 'textarea'

  @Prop({ type: String, default: '' })
  value!: string

  @Prop({ type: String, default: '' })
  width!: string

  @Prop({ type: String, default: '' })
  innerWidth!: string

  @Prop({ type: String, default: '' })
  default!: string

  @Prop({ type: Array, default: [] })
  options!: string[]

  @Prop({ type: String, default: '' })
  label!: string

  id = shortid.generate()

  get inputValue() {
    try {
      return JSON.parse(this.value || '[]')
    } catch (e) {
      return []
    }
  }
  set inputValue(newOptions: string[]) {
    this.$emit('input', JSON.stringify(newOptions))
    this.$nextTick(() => this.$emit('change'))
  }

  screenWidth = 50

  mounted() {
    if (!this.$el) return
    let width = Math.floor(this.$el.clientWidth / 8) - 15
    if (width > 50) width = 50
    this.screenWidth = width
  }

  @Prop({ type: Function, default: () => true })
  validator!: (answer: string) => boolean

  get valid() {
    return this.validator(JSON.stringify(this.inputValue || []))
  }

  get required() {
    return !this.validator('')
  }
}
